export var phone_regex = /^\d{10}$/;
export var zipcode_regex = /^\d{5}$/;


// WEBPACK FOOTER //
// ./app/helpers/reg-ex.ts